// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuItem_menuItem__HyydK {
    margin-top: 1px;
    white-space: nowrap;
    transition-delay: 250ms;
    transition: background-color 400ms ease-out;

    &:hover {
        background-color: #1e1e1e;
    }

    &.MenuItem_openMenuItem__5cNtL {
        background-color: var(--color-darkui-surface-3);
        transition: background-color 400ms ease-out 250ms;
    }

    &.MenuItem_menuItemChild__BZObs {
        margin-top: 0;
    }
}

.MenuItem_menuItemLink__vlOgi {
    position: relative;
    display: flex;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    outline: none;
    white-space: nowrap;
    padding: 8px 15px 8px 20px;

    &.MenuItem_readOnly__XrvjS {
        cursor: not-allowed;
        pointer-events: none;
    }

    &:hover,
    &:focus {
        text-decoration: none;
    }

    &.MenuItem_active__em8Nk {
        border-left: 4px solid var(--color-white);
        padding-left: 16px;
        transition: border-left-color 300ms ease;

        .MenuItem_newsfeedUnreadBubble__W4zq4 {
            left: 38px;
        }
    }

    .MenuItem_menuItemText__V4cQ5 {
        font-size: 16px;
        font-weight: 100;
        color: var(--color-white);
        padding-right: 10px;
        max-height: 200px;
        flex-grow: 1;
        transition: max-height 800ms;
        transition-delay: 250ms;
        opacity: 0;
        animation: MenuItem_expanding__m0agN 500ms ease 125ms 1 normal forwards;
    }

    .MenuItem_newsfeedUnreadBubble__W4zq4 {
        background: var(--color-blue-primary);
        border-radius: 100%;
        z-index: 1;
        min-width: 6px;
        height: 6px;
        position: absolute;
        top: 8px;
        left: 42px;
    }

    i,
    .MenuItem_reactIcon__zW8S\\+ {
        margin-top: 0;
        margin-right: 20px;
        font-size: 20px;
        display: inline-block;
        transition: filter 300ms, opacity 300ms, -webkit-filter 300ms;
    }

    .MenuItem_dropdownArrow__Yl51G {
        opacity: 0.5;
        text-align: center;
        margin-left: auto;
        margin-right: 0;
        speak: none;
        transition: transform 300ms ease-in;

        &.MenuItem_open__x4arh {
            transform: rotate(-180deg);
            -ms-transform: rotate(-180deg);
        }
    }

    &.MenuItem_withIconUI__pJA-D {
        padding-bottom: 5px;
        padding-top: 5px;
    }

    .MenuItem_reactIcon__zW8S\\+ {
        margin-top: 0;
        margin-right: 10px;
    }
}

.MenuItem_menuItemLinkChild__F-82o {
    padding: 5px 5px 5px 55px;

    &.MenuItem_readOnly__XrvjS {
        cursor: not-allowed;
        pointer-events: none;
    }

    &.MenuItem_activeChild__EqjyZ {
        background-color: var(--color-112);
    }

    .MenuItem_menuItemText__V4cQ5 {
        font-size: 14px;
        color: #fff;

        &.MenuItem_actionItem__duVZM {
            color: var(--color-blue-light-1);
        }
    }
}

.MenuItem_children__mYiDm {
    max-height: 0;
    overflow: hidden;
    padding: 0;
    margin: 0;
    visibility: hidden;
    list-style-type: none;
    transition: max-height 250ms ease, padding 250ms ease, margin 250ms ease, visibility 0s ease 250s;

    &.MenuItem_openChildren__yGmjd {
        max-height: 1000px;
        padding: 0 0 8px 0;
        margin: 0 0 8px 0;
        visibility: visible;
        transition: max-height 250ms ease, padding 250ms ease, margin 250ms ease, visibility 0s ease 250ms;
    }
}

.MenuItem_collapsed__5\\+K5s {
    .MenuItem_menuItemLink__vlOgi {
        &.MenuItem_active__em8Nk {
            border-left-color: var(--color-102);
        }

        .MenuItem_menuItemText__V4cQ5 {
            opacity: 0;
        }
    }

    .MenuItem_menuItemText__V4cQ5 {
        --collapseOpacityStart: 1;
        animation: MenuItem_collapsing__ztjKi 500ms ease;
    }

    .MenuItem_menuItemText__V4cQ5.MenuItem_forceClear__-JVvw {
        --collapseOpacityStart: 0;
    }

    i,
    .MenuItem_reactIcon__zW8S\\+ {
        filter: grayscale(1) opacity(0.6);
        -webkit-filter: grayscale(1) opacity(0.6);
    }
}

@keyframes MenuItem_expanding__m0agN {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes MenuItem_collapsing__ztjKi {
    0% {
        opacity: var(--collapseOpacityStart);
    }
    100% {
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/MainSidebar/components/MenuItem.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;;IAE3C;QACI,yBAAyB;IAC7B;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,0BAA0B;;IAE1B;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,yCAAyC;QACzC,kBAAkB;QAClB,wCAAwC;;QAExC;YACI,UAAU;QACd;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,mBAAmB;QACnB,iBAAiB;QACjB,YAAY;QACZ,4BAA4B;QAC5B,uBAAuB;QACvB,UAAU;QACV,uEAAuD;IAC3D;;IAEA;QACI,qCAAqC;QACrC,mBAAmB;QACnB,UAAU;QACV,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,UAAU;IACd;;IAEA;;QAEI,aAAa;QACb,kBAAkB;QAClB,eAAe;QACf,qBAAqB;QACrB,6DAA6D;IACjE;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,WAAW;QACX,mCAAmC;;QAEnC;YACI,0BAA0B;YAC1B,8BAA8B;QAClC;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;;IAEzB;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,eAAe;QACf,WAAW;;QAEX;YACI,gCAAgC;QACpC;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,iGAAiG;;IAEjG;QACI,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,kGAAkG;IACtG;AACJ;;AAEA;IACI;QACI;YACI,mCAAmC;QACvC;;QAEA;YACI,UAAU;QACd;IACJ;;IAEA;QACI,yBAAyB;QACzB,gDAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,iCAAiC;QACjC,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".menuItem {\n    margin-top: 1px;\n    white-space: nowrap;\n    transition-delay: 250ms;\n    transition: background-color 400ms ease-out;\n\n    &:hover {\n        background-color: #1e1e1e;\n    }\n\n    &.openMenuItem {\n        background-color: var(--color-darkui-surface-3);\n        transition: background-color 400ms ease-out 250ms;\n    }\n\n    &.menuItemChild {\n        margin-top: 0;\n    }\n}\n\n.menuItemLink {\n    position: relative;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    cursor: pointer;\n    outline: none;\n    white-space: nowrap;\n    padding: 8px 15px 8px 20px;\n\n    &.readOnly {\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n\n    &:hover,\n    &:focus {\n        text-decoration: none;\n    }\n\n    &.active {\n        border-left: 4px solid var(--color-white);\n        padding-left: 16px;\n        transition: border-left-color 300ms ease;\n\n        .newsfeedUnreadBubble {\n            left: 38px;\n        }\n    }\n\n    .menuItemText {\n        font-size: 16px;\n        font-weight: 100;\n        color: var(--color-white);\n        padding-right: 10px;\n        max-height: 200px;\n        flex-grow: 1;\n        transition: max-height 800ms;\n        transition-delay: 250ms;\n        opacity: 0;\n        animation: expanding 500ms ease 125ms 1 normal forwards;\n    }\n\n    .newsfeedUnreadBubble {\n        background: var(--color-blue-primary);\n        border-radius: 100%;\n        z-index: 1;\n        min-width: 6px;\n        height: 6px;\n        position: absolute;\n        top: 8px;\n        left: 42px;\n    }\n\n    i,\n    .reactIcon {\n        margin-top: 0;\n        margin-right: 20px;\n        font-size: 20px;\n        display: inline-block;\n        transition: filter 300ms, opacity 300ms, -webkit-filter 300ms;\n    }\n\n    .dropdownArrow {\n        opacity: 0.5;\n        text-align: center;\n        margin-left: auto;\n        margin-right: 0;\n        speak: none;\n        transition: transform 300ms ease-in;\n\n        &.open {\n            transform: rotate(-180deg);\n            -ms-transform: rotate(-180deg);\n        }\n    }\n\n    &.withIconUI {\n        padding-bottom: 5px;\n        padding-top: 5px;\n    }\n\n    .reactIcon {\n        margin-top: 0;\n        margin-right: 10px;\n    }\n}\n\n.menuItemLinkChild {\n    padding: 5px 5px 5px 55px;\n\n    &.readOnly {\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n\n    &.activeChild {\n        background-color: var(--color-112);\n    }\n\n    .menuItemText {\n        font-size: 14px;\n        color: #fff;\n\n        &.actionItem {\n            color: var(--color-blue-light-1);\n        }\n    }\n}\n\n.children {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    visibility: hidden;\n    list-style-type: none;\n    transition: max-height 250ms ease, padding 250ms ease, margin 250ms ease, visibility 0s ease 250s;\n\n    &.openChildren {\n        max-height: 1000px;\n        padding: 0 0 8px 0;\n        margin: 0 0 8px 0;\n        visibility: visible;\n        transition: max-height 250ms ease, padding 250ms ease, margin 250ms ease, visibility 0s ease 250ms;\n    }\n}\n\n.collapsed {\n    .menuItemLink {\n        &.active {\n            border-left-color: var(--color-102);\n        }\n\n        .menuItemText {\n            opacity: 0;\n        }\n    }\n\n    .menuItemText {\n        --collapseOpacityStart: 1;\n        animation: collapsing 500ms ease;\n    }\n\n    .menuItemText.forceClear {\n        --collapseOpacityStart: 0;\n    }\n\n    i,\n    .reactIcon {\n        filter: grayscale(1) opacity(0.6);\n        -webkit-filter: grayscale(1) opacity(0.6);\n    }\n}\n\n@keyframes expanding {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes collapsing {\n    0% {\n        opacity: var(--collapseOpacityStart);\n    }\n    100% {\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuItem": `MenuItem_menuItem__HyydK`,
	"openMenuItem": `MenuItem_openMenuItem__5cNtL`,
	"menuItemChild": `MenuItem_menuItemChild__BZObs`,
	"menuItemLink": `MenuItem_menuItemLink__vlOgi`,
	"expanding": `MenuItem_expanding__m0agN`,
	"readOnly": `MenuItem_readOnly__XrvjS`,
	"active": `MenuItem_active__em8Nk`,
	"newsfeedUnreadBubble": `MenuItem_newsfeedUnreadBubble__W4zq4`,
	"menuItemText": `MenuItem_menuItemText__V4cQ5`,
	"reactIcon": `MenuItem_reactIcon__zW8S+`,
	"dropdownArrow": `MenuItem_dropdownArrow__Yl51G`,
	"open": `MenuItem_open__x4arh`,
	"withIconUI": `MenuItem_withIconUI__pJA-D`,
	"menuItemLinkChild": `MenuItem_menuItemLinkChild__F-82o`,
	"activeChild": `MenuItem_activeChild__EqjyZ`,
	"actionItem": `MenuItem_actionItem__duVZM`,
	"children": `MenuItem_children__mYiDm`,
	"openChildren": `MenuItem_openChildren__yGmjd`,
	"collapsed": `MenuItem_collapsed__5+K5s`,
	"collapsing": `MenuItem_collapsing__ztjKi`,
	"forceClear": `MenuItem_forceClear__-JVvw`
};
export default ___CSS_LOADER_EXPORT___;
